class PaymentGatewayModel{
    paymentGatewayId:number;
    merchantId?:string;
    typeId: string;
    paymentGatewayName: string;
    gatewayApiKey: string;
    gatewaySecretKey: string;
    
}

export default PaymentGatewayModel;